import { render, staticRenderFns } from "./SpecificItem.vue?vue&type=template&id=93b75ede&scoped=true"
import script from "./SpecificItem.vue?vue&type=script&lang=js"
export * from "./SpecificItem.vue?vue&type=script&lang=js"
import style0 from "./SpecificItem.vue?vue&type=style&index=0&id=93b75ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b75ede",
  null
  
)

export default component.exports